export enum MatchStatuses {
	TimeToBeDefined = 'TBD',
	NotStarted = 'NS',
	FirstHalf = '1H',
	Halftime = 'HT',
	SecondHalf = '2H',
	ExtraTime = 'ET',
	BreakTime = 'BT',
	PenaltyInProgress = 'P',
	Suspended = 'SUSP',
	Interrupted = 'INT',
	Finished = 'FT',
	FinishedAfterExtraTime = 'AET',
	FinishedAfterPenaltyShootout = 'PEN',
	Postponed = 'PST',
	Cancelled = 'CANC',
	Abandoned = 'ABD',
	TechnicalLoss = 'AWD',
	Walkover = 'WO',
	Live = 'LIVE',
}